import { useContext } from 'react';

import { useIsSharedView } from 'src/modules/renderings/hooks';
import {
  renderingHubContext,
  renderingSharedContext,
} from 'src/modules/renderings/provider';

const useRenderingContext = () => {
  const isSharedView = useIsSharedView();
  const renderingHubContextValues = useContext(renderingHubContext);
  const sharedContextValues = useContext(renderingSharedContext);
  return isSharedView ? sharedContextValues : renderingHubContextValues;
};

export { useRenderingContext };
